import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { User } from 'src/types/user/user';

type UserState = {
  user: User | null;
  loading: boolean;
  error: string | null;
};

type Actions = {
  setLoading: (loading: boolean) => void;
  setUser: (newUser: User | null) => void;
  setUserFromLogin: (user: any) => void;
  clearUser: () => void;
};

const initialValues: UserState = {
  user: null,
  loading: false,
  error: null,
};

export const useUserStore = create<UserState & Actions>()(
  persist(
    (set) => ({
      ...initialValues,

      setLoading: (loading: boolean) => set({ loading }),

      setUser: (user: User | null) => set({ user }),

      setUserFromLogin: (userMe: any) => {
        if (userMe) {
          const user: User = {
            id: userMe.id,
            name: userMe.name,
            cpf: userMe.cpf,
            phone: userMe.phone,
          };
          set({ user });
        }
      },

      clearUser: () => set({ user: null, error: null }),
    }),
    {
      name: 'user-storage',
      partialize: (state) => ({ user: state.user }),
    }
  )
);
